import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { environment } from "../../../environments/environment";
import { O2OIndustrySectorService } from "../services/o2o-industry-sector.service";
import { CommonSelectionInterface } from "../../share/interface/common.interface";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { O2OPartnerService } from "../services/o2o-partner.service";
import { O2OPartnerAddInterface } from "../interfaces/o2o-partner.interface";
import { AlertService } from "../../share/service/alert.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidatorFunction } from "src/app/share/function/validator.function";

@Component({
  selector: "app-partner-save",
  templateUrl: "./partner-save.component.html",
  styleUrls: ["./partner-save.component.scss"]
})
export class PartnerSaveComponent implements OnInit, OnDestroy {
  form = this.fb.group({
    name: ["", Validators.required],
    industrySector: ["", Validators.required],
    subSector: [{ value: "", disabled: true }, Validators.required],
    registrationNo: ["", Validators.required],
    documents: [[] as File[], [ValidatorFunction.fileSize(5)]],
    themeColor: ["", Validators.required],
    urlSlug: ["", [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]],
    logo: [[] as File[], [Validators.required, ValidatorFunction.fileSize(5)]],
    banner: [[] as File[], [Validators.required, ValidatorFunction.fileSize(5)]]
  });

  industrySectors: CommonSelectionInterface[] = [];
  subSectors: CommonSelectionInterface[] = [];
  protected sections = [
    { id: "partner-details", label: "Partner Details" },
    { id: "partner-branding", label: "Partner's Branding" }
  ];
  protected readonly environment = environment;
  protected destroy$ = new Subject<void>();

  constructor(
    protected alertService: AlertService,
    protected fb: FormBuilder,
    protected o2oIndustrySectorService: O2OIndustrySectorService,
    protected o2oPartnerService: O2OPartnerService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loadIndustrySectors();
    this.subscribeToIndustrySectorChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  savePartner(): void {
    if (this.form.invalid) {
      return;
    }

    const {
      name,
      documents,
      banner,
      logo,
      themeColor,
      urlSlug,
      subSector,
      registrationNo
    } = this.form.value;

    const payload: O2OPartnerAddInterface = {
      name,
      companyDocuments: documents,
      banner,
      logo,
      themeColor,
      urlSlug,
      industrySectorId: subSector,
      registrationNo
    };

    this.o2oPartnerService.add(payload).subscribe({
      next: () => {
        this.alertService.openSnackBar("Partner saved successfully");
        this.router.navigate([".."], { relativeTo: this.route });
      },
      error: (err) => this.alertService.openSnackBar(err.error)
    });
  }

  private loadIndustrySectors(): void {
    this.o2oIndustrySectorService.getIndustrySectors().subscribe({
      next: (res) => {
        this.industrySectors = res;
      }
    });
  }

  private subscribeToIndustrySectorChanges(): void {
    this.form
      .get("industrySector")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value) {
          this.o2oIndustrySectorService.getSubIndustrySectors(value).subscribe({
            next: (res) => {
              this.subSectors = res;
              this.form.get("subSector").enable();
            }
          });
        } else {
          this.subSectors = [];
          this.form.get("subSector").disable();
          this.form.get("subSector").setValue("");
        }
      });
  }
}
